import classNames from "classnames";
import * as React from "react";

interface IProps {
  loading: boolean;
  className?: string;
}

class RbsLoadingContainer extends React.Component<IProps> {
  public render() {
    return (
      <div
        className={classNames(this.props.className, {
          loading: this.props.loading
        })}
      >
        {this.props.children}
        {this.props.loading && <div className="loading-overlay" />}
        {this.props.loading && (
          <div className="loading-indicator spinner">
            <div className="rect1" />
            <div className="rect2" />
            <div className="rect3" />
            <div className="rect4" />
            <div className="rect5" />
          </div>
        )}
      </div>
    );
  }
}

export default RbsLoadingContainer;
